{
  "game": "aom-retold",
  "patch": "19.17020",
  "checkedAt": "2026-10-17",
  "ages": [
    {
      "id": "archaic",
      "name": {
        "pt-BR": "Arcaica",
        "en": "Archaic"
      },
      "icon": "ages/archaic"
    },
    {
      "id": "classical",
      "name": {
        "pt-BR": "Clássica",
        "en": "Classical"
      },
      "icon": "ages/classical"
    },
    {
      "id": "heroic",
      "name": {
        "pt-BR": "Heroica",
        "en": "Heroic"
      },
      "icon": "ages/heroic"
    },
    {
      "id": "mythic",
      "name": {
        "pt-BR": "Mítica",
        "en": "Mythic"
      },
      "icon": "ages/mythic"
    }
  ],
  "pantheons": [
    {
      "id": "greeks",
      "name": {
        "pt-BR": "Gregos",
        "en": "Greeks"
      },
      "icon": "ui/pantheon-greeks"
    },
    {
      "id": "egyptians",
      "name": {
        "pt-BR": "Egípcios",
        "en": "Egyptians"
      },
      "icon": "ui/pantheon-egyptians"
    },
    {
      "id": "norse",
      "name": {
        "pt-BR": "Nórdicos",
        "en": "Norse"
      },
      "icon": "ui/pantheon-norse"
    },
    {
      "id": "atlanteans",
      "name": {
        "pt-BR": "Atlantes",
        "en": "Atlanteans"
      },
      "icon": "ui/pantheon-atlanteans"
    }
  ],
  "defaults": {
    "efficiency": 0.92,
    "tick": 1,
    "foodChain": ["hunt", "herd", "berries", "farm"],
    "norseFavorPerMinute": 0,
    "secondBuilderEfficiency": 0.6,
    "extraBuilderEfficiency": 0.3
  },
  "meta": {
    "source": "SPEC.md (project owner)",
    "checkedAt": "2026-10-17",
    "confidence": "medium",
    "note": "Simulation defaults. Food chain hunt → herd → berries → farm: owner, 2026-11-02. Population counts when a unit leaves the building (owner, measured): a unit that finishes with the population full waits inside the building and blocks its queue. Builder efficiencies from major_gods.xml (buildingefficiency 0.6, extrabuildingefficiency 0.3), game files 19.17020."
  }
}
